export default class ErrorLogger {

    static log(ex, data) {
        Raven.captureException(ex, {
            extra: data
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/infrastructure/error-logger.js
 **/